import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

// PAT-1025: the app's own scaffolder fields. The extension `name` is the id
// suffix (`scaffolder-form-field:scaffolder/<name>`); the `createFormField`
// `name` is the `ui:field` the templates reference, unchanged from the legacy
// `createScaffolderFieldExtension` registrations.

export const markdownEditorFormField = FormFieldBlueprint.make({
  name: 'markdown-editor',
  params: {
    field: async () => {
      const { MarkdownEditorField } =
        await import('../../components/scaffolder/MarkdownEditorField');
      return createFormField({
        name: 'MarkdownEditor',
        component: MarkdownEditorField,
      });
    },
  },
});

export const teamPickerFormField = FormFieldBlueprint.make({
  name: 'team-picker',
  params: {
    field: async () => {
      const { TeamPickerField } =
        await import('../../components/scaffolder/TeamPickerField');
      return createFormField({
        name: 'TeamPicker',
        component: TeamPickerField,
      });
    },
  },
});

export const githubTeamPickerFormField = FormFieldBlueprint.make({
  name: 'github-team-picker',
  params: {
    field: async () => {
      const { GithubTeamPickerField } =
        await import('../../components/scaffolder/GithubTeamPickerField');
      return createFormField({
        name: 'GithubTeamPicker',
        component: GithubTeamPickerField,
      });
    },
  },
});

export const githubRepoUrlPickerFormField = FormFieldBlueprint.make({
  name: 'github-repo-url-picker',
  params: {
    field: async () => {
      const [{ GithubRepoUrlPickerField }, { repoPickerValidation }] =
        await Promise.all([
          import('../../components/scaffolder/GithubRepoUrlPickerField'),
          import('@backstage/plugin-scaffolder'),
        ]);
      return createFormField({
        name: 'GithubRepoUrlPicker',
        component: GithubRepoUrlPickerField,
        validation: repoPickerValidation,
      });
    },
  },
});

// `ui:hideError` and the hidden Review row are set by the template, not here.
export const githubRepoNameFeedbackFormField = FormFieldBlueprint.make({
  name: 'github-repo-name-feedback',
  params: {
    field: async () => {
      const { GithubRepoNameFeedbackField, validateGithubRepoName } =
        await import('../../components/scaffolder/GithubRepoNameFeedbackField');
      return createFormField({
        name: 'GithubRepoNameFeedback',
        component: GithubRepoNameFeedbackField,
        validation: validateGithubRepoName,
      });
    },
  },
});

export const skeletonRequestFormField = FormFieldBlueprint.make({
  name: 'skeleton-request',
  params: {
    field: async () => {
      const { SkeletonRequestField, validateSkeletonRequest } =
        await import('../../components/scaffolder/SkeletonRequestField');
      return createFormField({
        name: 'SkeletonRequest',
        component: SkeletonRequestField,
        validation: validateSkeletonRequest,
      });
    },
  },
});

export const appFormFields = [
  markdownEditorFormField,
  teamPickerFormField,
  githubTeamPickerFormField,
  githubRepoUrlPickerFormField,
  githubRepoNameFeedbackFormField,
  skeletonRequestFormField,
];
